// eslint-disable react/no-multi-comp
import I18n from "i18n-js";
import React, { Component } from "react";
import { func, instanceOf, string, bool, oneOfType, object } from "prop-types";
import DatePicker from "react-datepicker";

/**
 * To be used with https://reactdatepicker.com#example-38 "Custom input"
 */
class TextualDateInput extends Component {
  static propTypes = {
    onClick: func,
    onChange: func,
    value: string,
    id: string,
    error: string,
    forwardedRef: oneOfType([func, object]),
  };

  static defaultProps = {
    onClick: () => {},
    onChange: () => {},
    value: null,
    id: null,
    error: null,
    forwardedRef: null,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { id, forwardedRef, error } = this.props;
    return (
      <div>
        <input
          id={id}
          onClick={this.props.onClick}
          onChange={this.props.onChange}
          value={this.props.value}
          className={`form-control ${error ? "is-invalid" : ""}`}
          ref={forwardedRef}
        />
      </div>
    );
  }
}

class LabelDateInput extends Component {
  static propTypes = {
    placeholder: string,
    onChange: func,
    defaultValue: instanceOf(Date),
    className: string,
    label: string,
    id: string,
    optional: bool,
    forwardedRef: oneOfType([func, object]),
    error: string,
  };

  static defaultProps = {
    placeholder: "JJ/MM/AAAA",
    onChange: () => {},
    defaultValue: null,
    className: null,
    label: null,
    id: null,
    optional: false,
    forwardedRef: null,
    error: null,
  };

  state = {
    value: this.props.defaultValue,
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  /**
   * @param {Date} newDate
   */
  onChange(newDate) {
    this.setState(
      {
        value: newDate,
      },
      () => this.props.onChange(this.state.value)
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const {
      placeholder,
      onChange, // eslint-disable-line no-unused-vars
      label,
      id,
      optional,
      forwardedRef,
      error,
      ...props
    } = this.props;

    return (
      <div className="form-group">
        <label htmlFor={id} className="custom-file-input">
          {label}
          {optional ? "" : "*"}
        </label>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          customInput={
            <TextualDateInput forwardedRef={forwardedRef} error={error} />
          }
          todayButton={I18n.t("form.todayButton")}
          selected={this.state.value}
          placeholderText={placeholder}
          onChange={this.onChange}
          id={id}
          withPortal
          fixedHeight
          {...props}
        />
        {error && (
          <div className="invalid-feedback d-block">
            <p key={error}>{error}</p>
          </div>
        )}
      </div>
    );
  }
}

export default LabelDateInput;
